import { dataVizLayout } from "@atlas-int/tokens";
import NoticeOverlay from "./NoticeOverlay";

export enum GraphNoticeType {
  Error = "error",
  RateLimit = "rateLimit",
  NoData = "noData",
  ZeroTrade = "zeroTrade",
  ComplexityNotAvailable = "complexityNotAvailable",
  HS22NotAvailable = "hs22NotAvailable",
  Default = "default",
  CountrySelectionRequired = "countrySelectionRequired",
  RegionNotDisplayed = "regionNotDisplayed",
}

const noticeMessages = {
  [GraphNoticeType.Error]: "There was an error loading the data",
  [GraphNoticeType.RateLimit]:
    "Too many requests. Please wait a moment and refresh the page.",
  [GraphNoticeType.NoData]: "No trade data reported for this selection",
  [GraphNoticeType.ZeroTrade]:
    "There was zero trade reported for this selection",
  [GraphNoticeType.ComplexityNotAvailable]:
    "Complexity visualizations are not available for regions and subregions",
  [GraphNoticeType.HS22NotAvailable]:
    "This visualization is not available for HS 2022",
  [GraphNoticeType.CountrySelectionRequired]:
    "A country selection is required for this visualization",
  [GraphNoticeType.RegionNotDisplayed]: "Region Not Displayed",
  [GraphNoticeType.Default]: "There was an error loading the data",
};

const GraphNotice = ({
  graphNoticeType,
}: {
  graphNoticeType: GraphNoticeType;
}) => {
  const noticeTextContent = noticeMessages[graphNoticeType];

  return (
    <NoticeOverlay visible={true} inset={dataVizLayout.noticeInset}>
      {noticeTextContent}
    </NoticeOverlay>
  );
};

export default GraphNotice;
